import {CardTypeType} from '@web/core/constants'
import {BankEasyPayView, CardEasyPay} from '@web/slices/priorityPaymentMethod/slice'

interface ConvertChargeAccountProps {
    accountKey: string
    bankCode: BankEasyPayView['bankCode']
    bankName: string
    maskedAccountNumber: string
    invalidReason?: string
}

export const convertChargeAccount = ({
    accountKey,
    bankCode,
    bankName,
    maskedAccountNumber,
    invalidReason,
}: ConvertChargeAccountProps): BankEasyPayView => {
    return {
        accountKey,
        bankCode,
        bankName,
        maskedAccountNumber,
        associatedCheckCard: false,
        maintenanceSchedule: null,
        nickName: null,
        payable: true,
        payPartnershipItemCode: '',
        payPartnershipItemName: '',
        // TODO:(정기구독 전환) 받을 수 있는 값인지 확인
        registrationCompletedDateTime: 'registrationCompletedDateTime',
        invalidReason: invalidReason ?? null,
    }
}

interface ConvertCardProps {
    cardCompanyCode: CardEasyPay['cardCompanyCode']
    cardId: string
    cardImageUrl: string
    cardName: string
    maskedCardNumber: string
    invalidReason?: string
    cardType: CardTypeType
}

export const convertCard = ({
    cardCompanyCode,
    cardId,
    cardImageUrl,
    cardName,
    maskedCardNumber,
    invalidReason,
    cardType,
}: ConvertCardProps): CardEasyPay => {
    return {
        cardCompanyCode,
        cardId,
        cardImageUrl,
        cardName,
        maskedCardNumber,
        payServiceAvailable: true,
        cardCategory: '',
        cardIssuerCode: null,
        cardOwnerType: null,
        cardProductCode: '',
        isHyundaiPlccCard: false,
        hyundaiPlccCardType: null,
        isRewardCard: false,
        longTermInstallment: false,
        payServiceMaintenanceSchedule: null,
        registeredDateTime: '',
        rewardAccumulateRate: 0,
        rewardPointResidualAmount: 0,
        cardCompanyId: 'CCBC',
        cardType,
        invalidReason: invalidReason ?? null,
    }
}
